import React, {useEffect, useState} from 'react';
import {Button, Drawer, Radio, Table} from 'antd';
import {getPtoAccrualSchedule} from '../api/ptoApi';
import moment from 'moment';
import _ from 'lodash';

import {minutesToHours, PREFERRED_DATE_FORMAT} from '../util/time';
import {DownloadOutlined} from "@ant-design/icons";
import {Parser} from 'json2csv';
import {getPaginationConfig} from "../util/showAllPagination";

const AccrualSchedule = ({employee, showAccrualSchedule, hideAccrualSchedule}) => {
  const SCHEDULE_ROLLOVER = 0;
  const SCHEDULE_ACCRUAL = 1;
  const SCHEDULE_TIMEOFF = 2;
  const [accruals, setAccruals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isHours, setIsHours] = useState(true);
  const options = [
    {label: 'Hours', value: true},
    {label: 'Minutes', value: false},
  ];

  const columns = [
    {
      title: 'Bucket',
      dataIndex: 'bucket',
      width: '25%',
    },
    {
      title: 'Date',
      width: '15%',
      render: record => moment.utc(record.date).format(PREFERRED_DATE_FORMAT)
    },
    {
      title: 'Rollover',
      hidden: !isHours,
      align: 'right',
      width: '20%',
      render: record => record.type === SCHEDULE_ROLLOVER ? minutesToHours(record.value) : '-'
    },
    {
      title: 'Rollover',
      hidden: isHours,
      align: 'right',
      width: '20%',
      render: record => record.type === SCHEDULE_ROLLOVER ? record.value : '-'
    },
    {
      title: 'Accrual',
      hidden: !isHours,
      align: 'right',
      width: '20%',
      render: record => record.type === SCHEDULE_ACCRUAL ? minutesToHours(record.value) : '-'
    },
    {
      title: 'Accrual',
      hidden: isHours,
      align: 'right',
      width: '20%',
      render: record => record.type === SCHEDULE_ACCRUAL ? record.value : '-'
    },
    {
      title: 'TimeOff',
      hidden: !isHours,
      align: 'right',
      width: '20%',
      render: record => record.type === SCHEDULE_TIMEOFF ? minutesToHours(record.value) : '-'
    },
    {
      title: 'TimeOff',
      hidden: isHours,
      align: 'right',
      width: '20%',
      render: record => record.type === SCHEDULE_TIMEOFF ? record.value : '-'
    },
    {
      title: 'Balance',
      hidden: !isHours,
      align: 'right',
      width: '20%',
      render: record => minutesToHours(record.balance)
    },
    {
      title: 'Balance',
      hidden: isHours,
      align: 'right',
      width: '20%',
      render: record => record.balance
    }
  ].filter((item) => !item.hidden);


  const load = async () => {
    try {
      setLoading(true);
      const schedule = await getPtoAccrualSchedule(employee.employee.email);
      let count = 0;
      let records = [];
      Object.keys(schedule || {}).forEach((key) => {
        const temp = schedule[key].map(a => ({
          type: a.Type,
          date: a.Date,
          value: a.Value,
          balance: a.Balance,
          sortDate: moment.utc(a.Date),
          key: count++,
          bucket: key
        }));
        records = _.concat(records, temp);
      });
      const sorted = _.chain(records).sortBy('sortDate').sortBy('bucket').value();

      setAccruals(sorted);
    } catch (e) {
      console.error(`Could not get PTO accruals for ${employee.employee.fullName}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line
  }, []);

  const exportSchedule = () => {
    const csvData = accruals
      .map(a => {
        return {
          'Bucket': a.bucket,
          'Date': moment.utc(a.date).format(PREFERRED_DATE_FORMAT),
          'Rollover H': a.type === SCHEDULE_ROLLOVER ? (a.value / 60).toFixed(2)  : null,
          'Accrual H': a.type === SCHEDULE_ACCRUAL ? (a.value / 60).toFixed(2)  : null,
          'PTO H': a.type === SCHEDULE_TIMEOFF ? (a.value / 60).toFixed(2)  : null,
          'Balance H': (a.balance / 60).toFixed(2),
          'Rollover M': a.type === SCHEDULE_ROLLOVER ? a.value : null,
          'Accrual M': a.type === SCHEDULE_ACCRUAL ? a.value : null,
          'PTO M': a.type === SCHEDULE_TIMEOFF ?  a.value : null,
          'Balance M':  a.balance
        }
      });
    const json2CsvParser = new Parser();
    const csv = json2CsvParser.parse(csvData);
    const blob = new Blob([csv], {type: 'text/csv', encoding: 'UTF-8'});
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `TimeOffAccrualSchedule-${employee.employee.email}-${moment().format('YYYYMMDD-hhmmss')}.csv`;
    link.click();
  }

  const onChange = e => {
    setIsHours(e.target.value);
  }

  return (
    <Drawer
      title={
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
    <span>
      TimeOff Accrual Schedule for {employee?.employee.fullName} ({employee?.employee.email})
    </span>
          <span>
          <Button
            onClick={exportSchedule}
            disabled={loading}
            icon={<DownloadOutlined/>}
            style={{marginRight: 10}}
          >
            Export
          </Button>
            <Radio.Group
              disabled={loading}
              options={options}
              onChange={onChange}
              value={isHours}
              optionType="button"
              buttonStyle="solid"
            />
        </span>
        </div>
      }
      bodyStyle={{height: '200px'}}
      height="100%"
      placement="bottom"
      closable={true}
      onClose={hideAccrualSchedule}
      open={showAccrualSchedule}
    >
      {employee && (
        <Table
          rowKey="key"
          dataSource={accruals}
          columns={columns}
          pagination={getPaginationConfig(accruals.length)}
          size="small"
          scroll={{y: 'calc(100vh - 210px)'}}
          loading={loading}
        />
      )}
    </Drawer>


  );
};

export {AccrualSchedule};